export const ConstConfig = {
  apiPath: '/api',
  authApiPath: '/api_passport',
  qiniuCdn: 'https://images.snsports.cn',
  qiniuUpload: 'https://upload.qiniup.com',
  wxAppId: 'wx83d351356eb8c592',
  qiniuCdn2: 'https://image.bjh.snsports.cn',
}
